// extracted by mini-css-extract-plugin
export default {"logo":"logo__nrCJC","text":"text__37wqi","image":"image__2jsOG"};